import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  limitText: {
    defaultValue:
      'Você atingiu o limite de tópicos favoritados. Remova da sua lista na área Tópicos para adicionar novos.',
    key: 'TerritoryFavorite-limitText',
  },
  successToast: {
    defaultValue: `O tópico foi adicionado na sua lista de favoritos! 

Você pode acompanhá-lo também na Home`,
    key: 'TerritoryFavorite-successToast',
  },
  removedToast: {
    defaultValue: `O tópico foi removido da sua lista de favoritos.`,
    key: 'TerritoryFavorite-removedToast',
  },
})
